export const SERVICES = {
  PHYSIOTHERAPY: {
    serviceId: '2',
    itemType: 'PHYSIOTHERAPY',
    displayName: 'Physiotherapy',
    routePrefix: 'physiotheraphy',
    categoryId: -1,
  },
  WEIGHT_MANAGEMENT: {
    serviceId: '3',
    itemType: 'WEIGHTLOSS',
    displayName: 'Weight Management',
    routePrefix: 'weight-management',
    categoryId: -1,
  },
};

export function getServiceByRoutePrefix(routePrefix) {
  return Object.values(SERVICES).find(service => service.routePrefix === routePrefix);
}

export function getServiceByType(serviceType) {
  const serviceKey = serviceType.toUpperCase().replace(/-/g, '_');
  return SERVICES[serviceKey];
}
